import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'big'
})
export class BigPipe implements PipeTransform {

  transform(value: string): string { return Number(value).toLocaleString('ch') }
}
